import { Form, TextFieldControl } from '@foxtaibox/foxtailbox-frontend-core';
import { Button, Stack } from '@mui/material';
import { authFieldSx } from 'pages/onboarding/styles';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type ResetPasswordFormData = {
  code: string;
  password: string;
  confirmPassword: string;
};

type ResetPasswordFormProps = {
  onSubmit: (data: ResetPasswordFormData) => void;
  loading?: boolean;
};

const ResetPasswordForm = ({ onSubmit, loading }: ResetPasswordFormProps) => {
  const { t } = useTranslation();
  const form = useForm<ResetPasswordFormData>();
  const { handleSubmit } = form;

  return (
    <Form form={form}>
      <Stack spacing={3}>
        <TextFieldControl
          name='code'
          label={t('passwordReset.code')}
          placeholder={t('passwordReset.code')}
          type='text'
          rules={{ required: true }}
          disabled={loading}
          sx={authFieldSx}
        />
        <TextFieldControl
          name='password'
          label={t('password')}
          placeholder={t('password')}
          type='password'
          rules={{ required: true }}
          disabled={loading}
          sx={authFieldSx}
        />
        <TextFieldControl
          name='confirmPassword'
          label={t('register.repeatPassword')}
          placeholder={t('register.repeatPassword')}
          type='password'
          rules={{
            required: true,
            validate: (value) =>
              value === form.getValues('password') || t('validation.passwordsMustMatch'),
          }}
          disabled={loading}
          sx={authFieldSx}
        />
        <Button variant='contained' size='large' loading={loading} onClick={handleSubmit(onSubmit)}>
          {t('passwordReset.resetButton')}
        </Button>
      </Stack>
    </Form>
  );
};

export default ResetPasswordForm;
